import React from 'react';

type Props = React.SVGProps<SVGSVGElement>;

export const ChevronDownIcon: React.FC<Props> = (props) => (
  <svg width="9" height="6" viewBox="0 0 9 6" fill="currentColor" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M1.0575 0.44L4.5 3.87655L7.9425 0.440001L9 1.49798L4.5 6L0 1.49798L1.0575 0.44Z" />
  </svg>
);
